export default __webpack_public_path__ + "static/media/card-w-review.a7644f64.png";